module.exports = __webpack_public_path__ + "media/images/athletes/1585-69975732a65c0a2427bcc5c898a10a9c.png";